import { useQuery } from "@tanstack/react-query";
import { auxiliaryQueryKeys } from "../queryKeys";

export interface SpawnedFromResponse {
  spawnedFromPlaylineId: string | null;
  spawnedFromScenarioId: string | null;
  sourceScenarioTitle: string | null;
}

export function useScenarioSpawnNotification(
  baseUrl: string,
  scenarioId: string,
) {
  return useQuery<SpawnedFromResponse, Error>({
    queryKey: auxiliaryQueryKeys.spawnedFrom({ baseUrl, scenarioId }),
    queryFn: async () => {
      const response = await fetch(
        `${baseUrl}/scenarios/${encodeURIComponent(scenarioId)}/spawned-from`,
        { method: "GET", headers: { Accept: "application/json" } },
      );
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return (await response.json()) as SpawnedFromResponse;
    },
    retry: false,
  });
}
